import React from 'react';
import braudlist from '../../resources/braud.json';
import { Vara } from '../../components/vara';
import './styles.css';

const Braud = () => {

  const getImagePath = (imageName) => {
    return require(`../../resources/braud/${imageName}`);
  };

  const bannerUrl = require('../../resources/Coverbraud.JPG');

  return (
    <div className="min-h-screen bg-[#FAF7F2]">
      <div className="relative h-52 w-full overflow-hidden">
        <img src={bannerUrl} alt="Brauð" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-black/40 flex flex-col items-center justify-center text-center px-4">
          <h1 className="text-4xl font-serif text-white mb-2">Brauð</h1>
          <div className="w-12 h-0.5 bg-[#C29979] mb-3"></div>
          <p className="text-white/80 font-serif text-sm">Brauðin okkar, bökuð ný alla morgna</p>
        </div>
      </div>
      <div className="max-w-5xl mx-auto px-4 py-10">
        <ul className="flex flex-wrap justify-center">
          {braudlist.items.map((braud) => (
            <Vara
              key={braud.id}
              name={braud.name}
              image={getImagePath(braud.images)}
              description={braud.description}
            />
          ))}
        </ul>
      </div>
    </div>
  );

};

export default Braud;
